// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2xOhC","inputDescription":"styles_inputDescription__uQ2KO"};